import ActionResult from './../Common/action-result';
import { ErrorTypes, WpEvent, WpEventHandler } from './../Common';
import { AppSettings } from './app-settings';
import AppSettingsInitializedEventArgs from './app-settings-initialized-event-args';
import GlobalService from './global-service';
import { IContext } from '../Identity';
import { IdentitySymbols } from '../Identity/symbols';


export default class Initializer {
    private static _settingsInitialized: WpEventHandler<AppSettingsInitializedEventArgs> = new WpEventHandler<AppSettingsInitializedEventArgs>();

    static get SettingsInitialed(): WpEvent<AppSettingsInitializedEventArgs> {
        return this._settingsInitialized;
    }

    static async InitializeAsync(globalService: GlobalService): Promise<ActionResult> {
        let settings = GlobalService.GetSettings();
        //let context = globalService.Get<IContext>(IdentitySymbols.Context);
        //await context.Initialize(settings, globalService);

        try {
            this._settingsInitialized.Send(this, new AppSettingsInitializedEventArgs(settings));

            return ActionResult.SuccessData();
        }
        catch (e) {
            return ActionResult.FailedData(ErrorTypes.InternalError);
        }
    }
}
